import React from "react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { managementTeam } from "../data/mock";

const Management = () => {
  return (
    <div>
      <PageHero
        eyebrow="Corporate / Management"
        title="Leadership"
        subtitle="Meet the promoters, directors and independent directors guiding Quality Power's global growth."
      />
      <section className="px-6 pb-24">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {managementTeam.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.05}>
              <GlassCard tilt className="p-7 h-full flex flex-col">
                <div className="flex items-center gap-4 mb-5">
                  <span className="w-14 h-14 rounded-full flex items-center justify-center font-display font-bold text-lg bg-qcyan/10 border border-qcyan/30 text-qcyan shrink-0">
                    {m.initials}
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-foreground text-base leading-tight">{m.name}</h3>
                    <p className="text-xs text-qamber uppercase tracking-wide mt-1">{m.title}</p>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">{m.bio}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Management;
